import { NotificationContainer, NotificationManager } from 'react-notifications';
import { keys } from 'underscore';

import { apiUrl } from '../config/site'

export default {

	lastRequest: null,

	isFormData: false,

	toQueryString: (obj) => {
        return keys(obj).map( i =>
            ( encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]) )
        ).join("&");
    },

	get: function( url, data, callback ) {
		this.isFormData = false;
        return this.request( 'GET', url + '?' + this.toQueryString(data), {}, callback );
	},

	post: function( url, data, callback ) {
		this.isFormData = false;
		return this.request( 'POST', url, data, callback );
	},

	put: function( url, data, callback ) {
		this.isFormData = false;
		return this.request( 'PUT', url, data, callback );
	},

	delete: function( url, data, callback ) {
		this.isFormData = false;
		return this.request( 'DELETE', url + '?' + this.toQueryString(data), {}, callback );
	},

	uploadFormData: function( method, url, data, callback ) {
		var formData = new FormData();
		for (var field in data) {
			var val = typeof data[field] == 'object' && !('name' in data[field])
				? JSON.stringify(data[field])
				: data[field];
			formData.append(field, val);
		}
		this.isFormData = true;
		return this.request(method, url, formData, callback)
	},

	request: function( method, url, data, callback ) {

		url = apiUrl + url;

		// Keep the last request to check against
		this.lastRequest = {
			method,
			url,
			args: data,
			isLoading: true,
			data: null
		}

		// Set the base options
		const options = { method };

		if( Object.keys(data).length > 0 ) {
			options.body = data;
		}
	
		// Set up the extra options for form data
		if( this.isFormData ) {
			options.contentType = false;
			options.processData = false;
			options.dataType = 'json';
		}

		return fetch(url, options)
			.then(async res => {
				const body = await res.json();
				if( !res.ok ) throw body;
				return body;
			})
			.then(data => {
				this.lastRequest.isLoading = false
				this.lastRequest.data = data
				if ( ! callback ) {
					return;
				}

				return callback( data, null /*, xhr.getAllResponseHeaders()*/ );
			})
			.catch( async error => {

				this.lastRequest.isLoading = false

				if( typeof error === 'array' ) error = error[0];

				if ( error && 'data' in error ) {

					this.lastRequest.data = error.data
					if ( ! callback ) return;

					console.error( error.data.status, error.message, ('visible' in error.data) && !!error.data.visible );
					if( ('visible' in error.data) && !!error.data.visible ) NotificationManager.error(error.message, '', 5000);
					if( error.data.status === 401 ) window.location = '/login?expired=true'

					callback( null, error );

				} else {

					callback( null, {message: 'Sorry, something went wrong'} );

				}

			} );

	},
}



// WEBPACK FOOTER //
// ./src/js/services/api.js